module.exports = __webpack_public_path__ + "img/lg_ring_y_e_null_0.89056759.png";